import { type FormEvent, useState } from 'react';
import { useSession } from '../session.tsx';

export function LoginPage() {
  const { login } = useSession();
  const [token, setToken] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(token.trim());
    } catch (err) {
      setError((err as Error).message.includes('401') ? 'Token no válido o revocado.' : (err as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login">
      <form className="card stack" onSubmit={submit}>
        <div className="brand" style={{ padding: 0 }}>
          <img src="/favicon.svg" width={30} height={30} alt="" />
          <span>
            Game Growth OS
            <small>Hive Interactive</small>
          </span>
        </div>
        <label className="field">
          <span>Token de API</span>
          <input
            className="input"
            type="password"
            autoComplete="current-password"
            value={token}
            onChange={(e) => setToken(e.target.value)}
            placeholder="ADMIN_TOKEN o gga_…"
            required
            autoFocus
          />
        </label>
        {error && <div className="error-box">{error}</div>}
        <button className="btn primary" type="submit" disabled={busy || !token.trim()}>
          {busy ? 'Comprobando…' : 'Entrar'}
        </button>
        <p className="muted small" style={{ margin: 0 }}>
          El token se guarda solo en este navegador. Crea tokens de lectura con <code>growth token create --name panel --scopes read</code>.
        </p>
      </form>
    </div>
  );
}
